import React from "react";
import styles from "./MapSection.module.css";
import useWindowWidth from "helpers/useWindowWidth";

function MapSection({settings}) {
  const width = useWindowWidth();

  return (
    <div className={styles.container}>
      <div className={styles.infoSection}>
        <div className={styles.header}>
          <h1 className={styles.title}>Our Office</h1>
          <p className={styles.subtitle}>
            Our company provides warehousing and distribution from our HQ.
          </p>
        </div>
        <div className={styles.contactGrid}>
          <div className={styles.contactItem}>
            <div className={styles.iconWrapper}>
              <img
                loading="lazy"
                src="/img/bodyshop/map-clock.svg"
                className={styles.icon}
                alt="Working hours icon"
              />
            </div>
            <div className={styles.contactDetails}>
              <h2 className={styles.contactTitle}>WORKING HOURS</h2>
              {settings?.workingHours && (
              <p className={styles.contactText}>
                {settings?.workingHours}
              </p>
              )}
            </div>
          </div>

          <div className={styles.contactItem}>
            <div className={styles.iconWrapper}>
              <img
                loading="lazy"
                src="/img/bodyshop/map-call.svg"
                className={styles.icon}
                alt="Call us icon"
              />
            </div>
            <a href={`tel:${settings?.contactNumber}}`}>
              <div className={styles.contactDetails}>
                <h2 className={styles.contactTitle}>CALL US</h2>
                {settings?.contactNumber && (
                <p className={styles.contactText}>
                  {settings?.contactNumber} <br /> Give us a call 24/7
                </p>
                )}
              </div>
            </a>
          </div>

          <div className={styles.contactItem}>
            <div className={styles.iconWrapper}>
              <img
                loading="lazy"
                src="/img/bodyshop/map-location.svg"
                className={styles.icon}
                alt="Location icon"
              />
            </div>
            <div className={styles.contactDetails}>
              <h2 className={styles.contactTitle}>ADDRESS</h2>
              {settings?.address && (
              <p className={styles.contactText}>{settings?.address}</p>
            )}
            </div>
          </div>
          <a href="mailto:support@bodyshopguru.com">
            <div style={{ cursor: "pointer" }} className={styles.contactItem}>
              <div className={styles.iconWrapper}>
                <img
                  loading="lazy"
                  src="/img/bodyshop/map-note.svg"
                  className={styles.icon}
                  alt="Write to us icon"
                />
              </div>
              <div className={styles.contactDetails}>
                <h2 className={styles.contactTitle}>WRITE TO US</h2>
                {settings?.email && (
                <p className={styles.contactText}>{settings?.email}</p>
              )}
              </div>
            </div>
          </a>
        </div>
      </div>
      <div className={styles.mapSection}>
        <iframe
          src={settings?.mapLocation}
          width="100%"
          height={width > 680 ? "100%" : "282px"}
          frameBorder="0"
          style={{ border: 0 }}
          allowFullScreen
          title="AboutUs"
        />
        {/* <div className={styles.mapControls}>
          <div className={styles.mapTypeButtons}>
            <button className={styles.mapButton}>Map</button>
            <button className={styles.mapButton}>Satellite</button>
          </div>
          <div className={styles.zoomControls}>
            <div className={styles.zoomPin}>
              <div className={styles.zoomPinInner}></div>
            </div>
            <div className={styles.zoomButtons}>
              <button className={styles.zoomButton}>+</button>
              <button className={styles.zoomButton}>-</button>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default MapSection;
